import { Box, Heading, Link, Stack, Text } from '@chakra-ui/react'
import NextLink from 'next/link'

type Props = {
  href: string
  title: string
  icon?: JSX.Element
  bgOffset?: number
  subheading?: string
}

export const Callout = ({ title, href, icon, bgOffset, subheading }: Props) => {
  let target = href.startsWith('http') ? '_blank' : '_self'

  return (
    <NextLink href={href} passHref legacyBehavior>
      <Link
        px={{ base: 4, lg: 8 }}
        py={{ base: 6, lg: 8 }}
        backgroundImage={"url('/img/nationHeroBackground.webp')"}
        backgroundColor='blue.900'
        backgroundPosition={`center ${bgOffset || 2}0%`}
        backgroundSize='1000%'
        borderRadius='lg'
        textColor='white'
        display='flex'
        flexWrap='wrap'
        justifyContent='center'
        textAlign='center'
        _hover={{
          textDecoration: 'none',
          fill: 'cyan.300',
          textShadow:
            '0px 0px 20px rgba(255,255,255,.25), 0px 0px 8px rgba(255,255,255,.25)',
        }}
        fill='cyan.500'
        target={target}>
        <Stack>
          {icon && (
            <Box width='100%' mb={{ base: 2, lg: 6 }}>
              {icon}
            </Box>
          )}
          <Heading mb={0} mt='auto' textTransform='uppercase'>
            {title}
          </Heading>
          {!!subheading && (
            <Text fontSize='sm' mt={2}>
              {subheading}
            </Text>
          )}
        </Stack>
      </Link>
    </NextLink>
  )
}
